import { Component, computed, inject, input, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Sensor } from 'libs/domain/sensor/sensor-interfaces';
import { SensorState } from 'libs/domain/sensor/sensor.enums';
import { SensorUIService } from 'libs/features/sensors/services/sensor-ui.service';
import { BadgeComponent } from 'libs/shared/components/ui/badge/badge.component';


@Component({
  selector: 'sensor-list-card',
  imports: [BadgeComponent],
  templateUrl: './sensor-list-card.html',
})
export class SensorListCard {
  route = inject(ActivatedRoute)

  sensor = input.required<Sensor>();

  sensorState = signal(SensorState);
  sensorUiService = inject(SensorUIService);

  sensorStateString = computed(() => {
    return this.sensorUiService.getSensorStateString(this.sensor()?.state);
  });
}
